
// components/MaintenanceWrapper.jsx
import React, { useEffect, useMemo, useState } from "react";
import MaintenanceBlockingScreen from "./MaintenanceBlockingScreen/MaintenanceBlockingScreen";
import MaintenanceBannerScreen from "./MaintenanceBannerScreen/MaintenanceBannerScreen";
import { paramsBase } from "../APIRoot";

const DEFAULT_STATE = {
  maintenanceMessages: null,
  portalsBlockingEnabled: false,
  failed: false,
};

const MaintenanceWrapper = ({children}) => { // ✅ no children here (used as Route element)
  const [maintenanceState, setMaintenanceState] = useState(DEFAULT_STATE);

  // Allows bypass via ?maintenance=disabled
  const bypassMaintenance = useMemo(
    () => new URLSearchParams(window.location.search).get("maintenance") === "disabled",
    []
  );

  useEffect(() => {
    let cancelled = false;

    const loadData = async () => {
      try {
        const resp = await fetch(
          process.env.REACT_APP_API_URL + "maintenance",
          paramsBase("GET", null, "application/json")
        );
        const data = await resp.json();
        if (!cancelled) {
          setMaintenanceState({ ...DEFAULT_STATE, ...data });
        }
      } catch (error) {
        if (!cancelled) {
          setMaintenanceState({ ...DEFAULT_STATE, failed: true });
        }
      }
    };

    loadData();
    return () => {
      cancelled = true;
    };
  }, []);

  const hasMessages = !!maintenanceState?.maintenanceMessages;

  // 1) HARD BLOCK
  if (hasMessages && maintenanceState.portalsBlockingEnabled && !bypassMaintenance) {
    const { dutchContent, frenchContent, englishContent, germanContent } =
      maintenanceState.maintenanceMessages;

    return (
      <MaintenanceBlockingScreen
        dutchContent={dutchContent}
        frenchContent={frenchContent}
        englishContent={englishContent}
        germanContent={germanContent}
      />
    );
  }

  // 2) SOFT BANNER WRAP (render children via <Outlet/> inside the banner)
  if (hasMessages && !bypassMaintenance) {
    const { dutchContent, frenchContent, englishContent, germanContent } =
      maintenanceState.maintenanceMessages;

    return (
      <MaintenanceBannerScreen
        dutchContent={dutchContent}
        frenchContent={frenchContent}
        englishContent={englishContent}
        germanContent={germanContent}
      >
        {/* ✅ nested routes render here */}
        {children}
      </MaintenanceBannerScreen>
    );
  }

  // 3) NORMAL FLOW
  return children;
};

export default MaintenanceWrapper;
